var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.572,
    height: 20.572,
    viewBox: "0 0 20.572 20.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(-360.214 -743.714)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    y2: 20.572,
    transform: "translate(370.5 743.714)",
    fill: "none",
    stroke: "#989da9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    y2: 20.572,
    transform: "translate(380.786 754) rotate(90)",
    fill: "none",
    stroke: "#989da9",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconGrey);
export default __webpack_public_path__ + "static/media/plus-icon-grey.66c9fa0efe6e42140b8fe00a6cc61576.svg";
export { ForwardRef as ReactComponent };